/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBusinessParentBody
 */
export interface UpdateBusinessParentBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessParentBody
     */
    parentId: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBusinessParentBody
     */
    purgeUsers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBusinessParentBody
     */
    purgeStripe?: boolean;
}

export function UpdateBusinessParentBodyFromJSON(json: any): UpdateBusinessParentBody {
    return UpdateBusinessParentBodyFromJSONTyped(json, false);
}

export function UpdateBusinessParentBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBusinessParentBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parentId': json['parentId'],
        'purgeUsers': !exists(json, 'purgeUsers') ? undefined : json['purgeUsers'],
        'purgeStripe': !exists(json, 'purgeStripe') ? undefined : json['purgeStripe'],
    };
}

export function UpdateBusinessParentBodyToJSON(value?: UpdateBusinessParentBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parentId': value.parentId,
        'purgeUsers': value.purgeUsers,
        'purgeStripe': value.purgeStripe,
    };
}


